export enum CancellationEnum {
  InsurerChange = 'InsurerChange',
  MoveIn = 'MoveIn',
  LessOneYear = 'LessOneYear',
  MoreOneYear = 'MoreOneYear'
}
